export default {
  areRequestsPending(state) {
    return state.pendingRequestCount > 0;
  },
};
